export default {
  templateSchedules: [],
};
